import $ from 'jquery';
import { createApp } from 'vue/dist/vue.esm-bundler.js'

//====---------Step 1: import all the individual components regardless if they are used inside other components.

import MapComponent from "Vue/mapcomponent/mapcomponent";

//====--------- Step 2: register each Main Category with a createApp

const MapComponentCategory = createApp({});


//====--------- Step 3: Mount the main category to a unique identifier and register the components within that category.

if ($("#js-store-locations").length > 0) {
	MapComponentCategory.component('mapcomponent', MapComponent);
	MapComponentCategory.mount("#js-store-locations");
}